import { createApp} from "vue";
import App from "./AppPost.vue";
document.addEventListener("DOMContentLoaded", () => {
  const postArea = document.getElementById('js-app');
  const commentsArea = document.getElementById('js-comments');
  const commentPostArea = document.getElementById('js-post-comment');

  if (postArea) {
    postArea.style.minHeight = postArea.clientHeight + 'px';
    setTimeout(() => {
      postArea.style.minHeight = '';
    }, 3000);
  }
  if (commentsArea) {
    commentsArea.style.minHeight = commentsArea.clientHeight + 'px';
    setTimeout(() => {
      commentsArea.style.minHeight = '';
    }, 3000);

    commentsArea.textContent = '';
  }
  if (commentPostArea) {
    commentPostArea.textContent = '';
  }

  if (postArea) {
    const app = createApp(App);
    app.provide('postId', Number(postArea.dataset.postId));
    app.provide('userId', Number(postArea.dataset.userId));
    app.mount(postArea);
  }
});
